<template>
  <div class="box_body">
    <div class="dr">
      <!-- 自定义提示框 -->
      <div class="alsrtInfo" :style="{display: displayStsates}" ref="alertMsg">
        <div class="profPrompt_test">{{aletMsg}}</div>
      </div>
      <ul>
        <li>

          <input @input="rule()" maxlength="12" type="text" v-model:value="parameter.account" placeholder="请输入账号" />
        </li>
        <li v-if="!pass_1off">
          <input
            type="password"
            maxlength="12"
            v-model:value="parameter.pass_0"
            placeholder="请输入密码"
          />
          <div>
            <span id="pass_img1" v-on:click="pass_1off = !pass_1off"></span>
          </div>
        </li>
        <li v-if="pass_1off">
          <input
            @input="rule()"
            type="text"
            maxlength="12"
            v-model:value="parameter.pass_0"
            placeholder="请输入密码"
          />
          <div class="pass_top">
            <span id="pass_img2" v-on:click="pass_1off = !pass_1off"></span>
          </div>
        </li>
        <li v-if="!pass_2off">
          <input type="password" maxlength="12" v-model:value="pass_1" placeholder="请再次输入密码" />
          <div class="pass_bottom" v-on:click="pass_2off = !pass_2off">
            <span id="pass_img1"></span>
          </div>
        </li>
        <li v-if="pass_2off">
          <input
            @input="rule()"
            type="text"
            maxlength="12"
            v-model:value="pass_1"
            placeholder="请再次输入密码"
          />
          <div>
            <span id="pass_img2" v-on:click="pass_2off = !pass_2off"></span>
          </div>
        </li>
        <li>
          <input type="text" v-model:value="parameter.shopname" placeholder="请输入店铺名称" />
        </li>
        <li>
          <input
            type="text"
            pattern="[0-9]*"
            maxlength="11"
            v-model:value="parameter.mobile"
            placeholder="请输入手机号"
          />
        </li>
        <li>
          <input
            type="text"
            v-model="carmodel"
            value
            readonly
            v-model:value="parameter.region"
            placeholder="请选择地区"
          />
          <div class="region_list">
            <i></i>
            <span id="region" @click="show = true"></span>
          </div>
        </li>
        <li>
          <input type="text" v-model:value="parameter.detailed" placeholder="请输入详细地址" />
        </li>
      </ul>
      <div class="remember">
        <router-link to="/">
          <span class="toEnter">已有账号去登入</span>
        </router-link>
      </div>
      <div id="btn-dr-parent">
        <div class="btn-dr">提交注册</div>
        <div v-on:click="register()" ref="coverage" class="btn_dr_block"></div>
      </div>
      <p>注册需要后台审核</p>
    </div>
    <!--cell+popup+area省市区的坑-->
    <van-popup v-model="show" position="bottom">
      <van-area
        ref="area"
        value="110000"
        :area-list="areaList"
        @change="onChange"
        @confirm="show = false"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
import areaObj from "../commonality/address3.js";
import API from "../../lmj_Api/api";

import { Cell, CellGroup, Popup, Field, Area, Picker } from "vant";
export default {
  components: {
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanPopup: Popup,
    VanField: Field,
    VanArea: Area,
    VanPicker: Picker
  },
  data() {
    return {
      show: false,
      carmodel: "",
      areaList: {
        province_list: areaObj.province_list,
        city_list: areaObj.city_list,
        county_list: areaObj.county_list
      },
      parameter: {
        account: "",
        pass_0: "",
        shopname: "",
        mobile: "",
        region: "",
        detailed: ""
      },
      pass_1: "",
      pass_1off: false,
      pass_2off: false,
      aletMsg: "", // 弹框提示语
      displayStsates: "none"
    };
  },
  //方法
  methods: {
    rule() {
      if (this.parameter.account != "") {
        this.parameter.account = this.parameter.account.replace(
          /[\u4e00-\u9fa5]/g,
          ""
        );
      }
      if (this.parameter.pass_0 != "") {
        this.parameter.pass_0 = this.parameter.pass_0.replace(
          /[\u4e00-\u9fa5]/g,
          ""
        );
      }
      if (this.pass_1 != "") {
        this.pass_1 = this.pass_1.replace(/[\u4e00-\u9fa5]/g, "");
      }
    },
    onChange(picker, value, index) {
      var i;
      var off = true;
      this.parameter.region = "";
      for (var i = 0; i < value.length; i++) {
        if (value[0].name == value[1].name && i < 2) {
          this.parameter.region += "-" + value[i + 1].name;
          off = false;
        } else if (off) {
          off = true;
          this.parameter.region += "-" + value[i].name;
        }
      }
        this.parameter.region = this.parameter.region.substring(1, this.parameter.region.length)

    },
    alertDia(msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 1000);
    },
    stopColor() {
      setTimeout(() => {
        this.$refs.coverage.style = "background:rgba(0,0,0,0)";
      }, 200);
    },

    register() {
      this.$refs.coverage.style = "background:rgba(0,0,0,0.1)";
      this.stopColor();
      //点击注册 处理
      if (
        this.parameter.account == "" ||
        this.parameter.pass_0 == "" ||
        this.parameter.shopname == "" ||
        this.parameter.mobile == "" ||
        this.parameter.region == "" ||
        this.parameter.detailed == ""
      ) {
        this.alertDia("必填项还未填写");
        return;
      } else if (this.parameter.pass_0 != this.pass_1) {
        this.alertDia("密码不一致");
        return;
      } else if (
        this.parameter.account.length > 12 ||
        this.parameter.account.length < 6
      ) {
        this.alertDia("账号限制6-12位");
        return;
      } else if (
        this.parameter.pass_0.length > 12 ||
        this.parameter.pass_0.length < 6
      ) {
        this.alertDia("密码限制6-12位");
        return;
      } else {
        // 发送请求
        let data = {
              username: this.parameter.account,
              password: this.parameter.pass_0,
              name: this.parameter.shopname,
              phone:  this.parameter.mobile,
              addr:  this.parameter.region,
              address:  this.parameter.detailed
        }
        var _this = this;
        _this.axios.post(API.registered,data)
        .then(res=>{
          console.log(res)
          let _data = res.data;
          if(_data.code == 200) {
            _this.alertDia(_data.msg);
            window.setTimeout(()=> {
              _this.$router.push({name: 'GoodsEnter'})
            },1100);
          }
          if(_data.code == 400) {
            _this.alertDia(_data.msg);
          }
        })

      }
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
}
.van-picker .van-picker__cancel {
  display: none !important;
}
.van-picker__confirm {
  margin-left: 70% !important;
}
#app, #app>div, body, html {
    width: 0; 
    height: 100%;
}
.box_body,html {
  width: 0;
  padding: 0;
  margin: 0rem 0.55rem;
  .dr {
    margin:0;
    width: 6.5rem;
    //提示框
    .alsrtInfo {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    .profPrompt_test {
      width: 4.2rem;
      height: 1.4rem;
      line-height: 1.4rem;
      border-radius: 0.2rem;
      color: #FFF;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.6);
      opacity: 0.6;
      top: 5.98rem;
      left: 50%;
      font-size: 0.28rem;
      font-family: Gotham-Book;
      opacity: 1;
      text-align: center;
      transform: translate(-50%, -50%);
    }
  }

    ul {
      list-style: none;
      li {
        position: relative;
        input[type="text"],
        input[type="password"] {
          display: block;
          height: 1.04rem;
          width: 6.4rem;
          margin: 0.22rem 0 0 0;
          border-radius: 0.3rem;
          font-size: 0.28rem;
          text-indent: 0.44rem;
          background: #eee;
          border: 0;
        }
        div {
          height: 0.66rem;
          position: absolute;
          bottom: 0rem;
          right: 0.05rem;
          z-index: 99;
          padding-top: 0.38rem;
          i {
              border-left: 0.04rem solid white;
              height: 0.4rem;
              position: absolute;
              top: 0.35rem;
              left: 0.1rem;
              -webkit-touch-callout: none;
             -webkit-user-select: none;
             -khtml-user-select: none;
             -moz-user-select: none;
             -ms-user-select: none;
             user-select: none;
          }
        }
        // .region_list {
        // }
        #pass_img1,
        #pass_img2,
        #region {
          display: block;
          margin-left: 0.4rem;
          width: 0.8rem;
          height: 0.37rem;
        }
        #pass_img1 {
          background: url("../../images/hb6.png") no-repeat;
          background-size: 0.46rem 0.465rem;
        }
        #pass_img2 {
          background: url("../../images/high_yj.png") no-repeat;
          background-size: 0.46rem 0.3rem;
        }
        #region {
          background: url("../../images/list_bottom.png") no-repeat;
          background-size: 0.4rem 0.4rem;
          background-position: 0;
        }
      }
      li::before {
        position: absolute;
        top: 0.375rem;
        left: 0.2rem;
        content: "*";
        clear: both;
        overflow: hidden;
        display: inline-block;
        color: lightcoral;
        font-size: 0.24rem;
      }
    }
    .remember {
      font-size: 0.28rem;
      .toEnter {
        margin: 0.22rem 0.2rem 0 0; 
        float: right;
        color: #5dbbff;
      }
    }
    #btn-dr-parent {
      width: 6.4rem;
      height: 1.08rem;
      position: relative;
      .btn-dr {
        margin-top: 1.22rem;
        line-height: 1.08rem;
        text-align: center;
        height: 1.08rem;
        font-size: 0.32rem;
        color: #fff;
        font-weight: 500;
        background: url("../../images/btn_blue.png") no-repeat;
        background-size: 100% 100%;
      }
      .btn_dr_block {
        position: absolute;
        top: 0px;
        left: 0px;
        height: 1.08rem;
        width: 6.4rem;
        z-index: 99;
        border-radius: 0.6rem;
      }
    }
    p {
      text-align: center;
      font-size: 0.24rem;
      width: 6.4rem;
      color: #ff5d33;
      margin: 0.22rem 0 0 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/goodsEnter/Adduser.vue